// Generated file - do not edit
export const env = {
  NODE_ENV: "production",
  KEEPEEK_FRONTEND_BASE_URL: "https://dam.plugin.valeoservice.systems",
  CKEDITOR_CDN_URL: "https://ckeditor.plugin.valeoservice.systems"
};
